module.exports = __webpack_public_path__ + "/images/cover-multi-recibiendo-dinero-002-it.d39eb4c.webp";